import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import {
    ModalHeader,
    ModalDescription,
    ModalContent,
    ModalActions,
    Button,
    Icon,
    Image,
    Modal,
    Table,
} from 'semantic-ui-react'

const ItineraryModal = ({ open, onClose, details }) => {

    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    const handleShowDetails = () => {
        setShowDetails(!showDetails)
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            trigger={<Button>Scrolling Content Modal</Button>}
        >
            <ModalHeader>{details.itinerary}</ModalHeader>
            <ModalContent image scrolling>
                <Table color="blue" striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>{t("day_number")}</Table.HeaderCell>
                            <Table.HeaderCell>{t("day_name")}</Table.HeaderCell>
                            <Table.HeaderCell>{t("day_am")}</Table.HeaderCell>
                            <Table.HeaderCell>{t("day_pm")}</Table.HeaderCell>
                            <Table.HeaderCell>{t("day_division")}</Table.HeaderCell>
                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {
                            details.days?.map((day) => (
                                <>
                                    <Table.Row key={day.id}>
                                        <Table.Cell>{day.number}</Table.Cell>
                                        <Table.Cell>{t(day.name)}</Table.Cell>
                                        <Table.Cell>{day.am}</Table.Cell>
                                        <Table.Cell>{day.pm}</Table.Cell>
                                        <Table.Cell>{day.transfer === 1 ? (<div>{t("yes")}</div>) : (<div>{t("not")}</div>)}</Table.Cell>

                                    </Table.Row>
                                    {showDetails && (
                                        <Table.Row >
                                            <Table.Cell colSpan="6" >{day.detail}</Table.Cell>
                                        </Table.Row>
                                    )}
                                </>
                            ))
                        }
                    </Table.Body>
                </Table>
            </ModalContent>
            <ModalActions>
                <Button primary onClick={handleShowDetails}>Ver detalles</Button>
                <Button onClick={onClose}>
                    Salir 
                </Button>
            </ModalActions>
        </Modal>
    )
}

export default ItineraryModal